import appConfig from '../config/app-config';

const API = appConfig.apis.geolocationApiEnv;
const baseUrl = API.address;

export class ApiError extends Error {
    constructor(public status: number, message: string) {
        super(message);
    }
}

const headers: Record<string, string> = { 'x-api-key': API.key };

const handleResponse = async (res: Response) => {
    if (res.ok) return res.json();
    throw new ApiError(res.status, `API error: ${res.status}`);
};

const get = async (path: string) => handleResponse(await fetch(`${baseUrl}${path}`, { headers }));

const qs = (params: Record<string, unknown>) => {
    const s = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') s.set(k, String(v)); });
    const str = s.toString();
    return str ? `?${str}` : '';
};

export const geoLocationApi = {
    getCitiesPageList: (params?: { page?: number; size?: number; sort?: string; province?: string; search?: string }) =>
        get(`/cities/page-list${qs(params || {})}`),

    getCityById: (id: number) => get(`/cities/${id}`),

    getCityHectarePrice: (cityId: number) => get(`/cities/${cityId}/hectare-price`),

    getProvinces: (fields?: string) => get(`/provinces${fields ? `?fields=${fields}` : ''}`),

    getProvinceById: (id: number) => get(`/provinces/${id}`),

    /**
     * Resolve um city_id numérico em nome da cidade + UF (a cidade aponta para a província).
     * Devolve null quando o id não existe / a API falha — o chamador decide o fallback.
     */
    resolveCity: async (cityId: number): Promise<ResolvedCity | null> => {
        if (!cityId) return null;
        try {
            const city = await get(`/cities/${cityId}?fields=id,name,province.initials`);
            if (!city?.name) return null;
            // com ?fields=, campos aninhados voltam achatados ("province.initials")
            const provinceInitials = city['province.initials'] || city.province?.initials || '';
            return { id: city.id, name: city.name, provinceInitials };
        } catch {
            return null;
        }
    },
};

export interface ResolvedCity {
    id: number;
    name: string;
    provinceInitials: string;
}
